import {useEffect, useState, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, CloseOutlined, CheckOutlined, SaveOutlined } from '@ant-design/icons';
import {FloatButton, Form, Row, Col, Divider, Button, message, Select, Switch, DatePicker, Tabs} from 'antd';
import {getData as get, update} from '../../../../apis/ConfiguracionNominaApi';
import {getList as getAllCalculos} from '../../../../apis/CalculosApi';
import {getList as getAllConceptos} from '../../../../apis/ConceptoApi';
import {getList as getAllTiposSaldos} from '../../../../apis/TipoSaldoApi';
import {getTiposAusentismo, updateTipoIncapacidad, updateOdooLeaveType, getIntegracion} from '../../../../apis/CalculoAguinaldoApi';
import {getConceptosVarable, updateConceptoVariable} from '../../../../apis/CalculoVariableApi';
import TiposEfectivoConfig from './TiposEfectivoConfig';
import _ from 'lodash'

const { Option } = Select;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración de Nómina</span>
      </>
    ),
}];

const ConfiguracionNominaPage = () => {
    let navigate = useNavigate();
    const [ form ] = Form.useForm()
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [setup, setSetup] = useState(false);
    const [required, setRequired] = useState(false);
    const [calculos, setCalculos] = useState([]);
    const [conceptos, setConceptos] = useState([]);
    const [tiposSaldos, setTiposSaldos] = useState([]);
    const [tiposAusentismos, setTiposAusentismos] = useState([]);
    const [ausentismosSeleccionados, setAusentismosSeleccionados] = useState({});
    const [integracion, setIntegracion] = useState([]);
    const [conceptosVariables, setConceptosVariables] = useState([]);

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
              await getInitialSettings();
              await refreshData();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
      setRequired(setup)
    }, [setup]);
    
    const refreshData = async ()=> {
      const response = await get();
      if(response.ok){
          setData(response.payload);
      }
    }

    const getInitialSettings = async ()=> {
      await getCalculos();
      await getConceptos();
      await getTiposSaldos();
      await loadTiposAusentismos();
      await getIntegraciones();
      await getConceptosVariables();
      setLoading(false);
    }

    const loadTiposAusentismos = async () => {
      const response = await getTiposAusentismo();
      if (response.ok) {
        const lista = response.payload || [];

        setTiposAusentismos(lista);

        const inicial = {};
        lista.forEach((item) => {
          const key = `${item.source}-${item.id}`;
          inicial[key] = !!item.activo;
        });
        setAusentismosSeleccionados(inicial);
      }
    };


    const getIntegraciones = async ()=> {
      const response = await getIntegracion();
      if(response.ok){
          setIntegracion(response.payload);
      }
    }

    const fechas = [
      { value: 'fecha_ingreso', text: 'Fecha de Ingreso (IMSS)' },
      { value: 'fecha_antiguedad', text: 'Fecha de Antigüedad' },
    ];

    const getCalculos = async ()=> {
      const response = await getAllCalculos();
      if(response.ok){
          setCalculos(response.payload);
      }
    }

    const getConceptos = async ()=> {
      const response = await getAllConceptos();
      if(response.ok){
          setConceptos(response.payload);
      }
    }

    const sortConceptosVariables = (list = []) => {
      return [...list].sort((a, b) => {
        const aNum = Number(a.clave);
        const bNum = Number(b.clave);
        const aVal = Number.isNaN(aNum) ? Number.MAX_SAFE_INTEGER : aNum;
        const bVal = Number.isNaN(bNum) ? Number.MAX_SAFE_INTEGER : bNum;
        return aVal - bVal;
      });
    }

    const getTiposSaldos = async ()=> {
      const response = await getAllTiposSaldos();
      if(response.ok){
          setTiposSaldos(response.payload);
      }
    }

    const getConceptosVariables = async ()=> {
      const response = await getConceptosVarable();
      if(response.ok){
          setConceptosVariables(sortConceptosVariables(response.payload));
      }
    }

    const handleChangeAusentismo = async (key, checked, item) => {
      const prevChecked = !!ausentismosSeleccionados[key];

      setAusentismosSeleccionados((prev) => ({
        ...prev,
        [key]: checked,
      }));

      try {
        if (item.source === 'tipo_incapacidad') {
          await updateTipoIncapacidad(item.id, checked);
        } else if (item.source === 'odoo_leave_type') {
          await updateOdooLeaveType(item.id, checked);
        }

        message.success(`Tipo de ausentismo "${item.nombre || item.tipo}" actualizado correctamente.`);
      } catch (err) {
        message.error(`Error al actualizar el tipo de ausentismo "${item.nombre || item.tipo}".`);

        // Revertir en caso de error
        setAusentismosSeleccionados((prev) => ({
          ...prev,
          [key]: prevChecked,
        }));
      }
    };

    const handleChangeConceptoVariable = async (id, checked, item) => {
      const prevConceptos = [...conceptosVariables];

      setConceptosVariables((prev) =>
        prev.map((concepto) =>
          concepto.id === id ? { ...concepto, activo: checked } : concepto
        )
      );

      try {
        await updateConceptoVariable(id, checked);
        message.success(`Concepto "${item.descripcion}" actualizado correctamente.`);
      } catch (err) {
        message.error(`Error al actualizar el concepto "${item.descripcion}".`);
        setConceptosVariables(prevConceptos);
      }
    };
    
    const handleOk = async () => {
      try {
        if(setup){
          const values = await form.validateFields();
          if(!values) return;
        }
      } catch (errorInfo) {
          console.log('Failed:', errorInfo);
          return;
      }

      const fields = form.getFieldsValue()
      const payload = {
          ...fields,
      }
      const response = await update(payload);
      if(response.ok){
          message.success('Se guardo correctamente la configuración!');
      }
  }


    return <PageApp routes={routes}
        title={'Configuración Módulo de Nómina'}>
      {
        data && 
        <Form 
            layout="vertical" 
            form={form} 
            requiredMark 
            initialValues={data} 
            autoComplete="off"
            onFinish={handleOk}>
            <FloatButton
              tooltip={<div>Guardar</div>} 
              icon={<SaveOutlined />}
              type="primary"
              style={{
                insetInlineEnd: 94,
              }}
              onClick={handleOk}
            />
            <Tabs
              defaultActiveKey="generales"
              items={[
                {
                  key: 'generales',
                  label: 'Generales',
                  children: (
                    <>
                      <Divider orientation="left" orientationMargin="0">Generales</Divider>
                      <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Form.Item
                                name="setup"
                                label="Setup"
                                >
                                <Switch onChange={(value)=>{setSetup(value)}} checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                            </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="manejo_horas_extras"
                              label="Manejo de Horas Extraso"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona una opción',
                              },
                              ]}
                          >
                            <Select placeholder="Por favor, selecciona una opción">
                              <Option value={0}>No limitar</Option>
                              <Option value={1}>Limitar</Option>
                              <Option value={3}>Horas Diarias</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="corte_horas_extras"
                              label="Corte de Horas Extraso"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona una opción',
                              },
                              ]}
                          >
                            <Select placeholder="Por favor, selecciona una opción">
                              <Option value={0}>Por Semana</Option>
                              <Option value={1}>Por Periodo</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="utilizar_confidencialidad"
                              label="Utilizar Confidencialidad"
                              >
                              <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="fecha_bloque_usuarios"
                              label="Fecha de Bloqueo Usuarios"
                          >
                            <DatePicker placeholder="DD/MM/YYYY" style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="fecha_bloque_todos"
                              label="Fecha de Bloqueo Todos"
                          >
                            <DatePicker placeholder="DD/MM/YYYY" style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider orientation="left" orientationMargin="0">Predeterminados Tablas</Divider>
                      <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="calculo_tabla_minimo"
                              label="Tabla de Mínimos"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un calculo',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      calculos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="calculo_tabla_istp"
                              label="Tabla de ISPT"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      calculos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="calculo_tabla_subsidio"
                              label="Tabla de Susbsidio"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      calculos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="calculo_tabla_uma"
                              label="Tabla de UMA"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      calculos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="calculo_tabla_umi"
                              label="Tabla de UMI"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      calculos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="calculo_tabla_cuotas_imss"
                              label="Tabla Cuotas IMSS"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      calculos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="concepto_fondo_ahorro_empleado"
                              label="Concepto Fondo Ahorro Empleado"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="concepto_fondo_ahorro_empresa"
                              label="Concepto Fondo Ahorro Empresa"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="concepto_aguinaldo"
                              label="Concepto Aguinaldo"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="concepto_vacaciones"
                              label="Concepto Vacaciones"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="concepto_ajuste_fraccionario"
                              label="Concepto Ajuste Fraccionario"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                              ]}
                          >
                              <Select placeholder="Por favor selecciona un concepto">
                                  {
                                      conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                              </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="tipo_saldo_infonavit"
                              label="Tipo de Saldo Infonavit"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Selecciona un tipo saldo',
                              },
                              ]}
                          >
                                <Select placeholder="Por favor selecciona un tipo saldo">
                                  {
                                      tiposSaldos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                                </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="tipo_saldo_fonacot"
                              label="Tipo de Saldo Fonacot"
                              rules={[
                              {
                                  required: setup,
                                  message: 'Selecciona un tipo saldo',
                              },
                              ]}
                          >
                                <Select placeholder="Por favor selecciona un tipo saldo">
                                  {
                                      tiposSaldos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                  }
                                </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider orientation="left" orientationMargin="0">Predeterminados Liquidaciones</Divider>
                      <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_fondo_ahorro"
                            label="Concepto Liquidación Fondo Ahorro"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_aguinaldo"
                            label="Concepto Liquidación Aguinaldo"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_vacaciones"
                            label="Concepto Liquidación Vacaciones"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_prima_vacacional"
                            label="Concepto Liquidación Prima Vacacional"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_prima_antiguedad"
                            label="Concepto Liquidación Prima Antiguedad"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_compensacion_fija"
                            label="Concepto Liquidación Compensación Fija"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_liquidacion_compensacion_variable"
                            label="Concepto Liquidación Compensación Variable"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider orientation="left" orientationMargin="0">Predeterminados Acumulados</Divider>
                      <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_total_neto"
                            label="Total Neto"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_percepcion_total"
                            label="Percepción Total"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_deducción_total"
                            label="Concepto Deducción Total"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_gravable_mensual"
                            label="Gravable Mensual"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_exento_mensual"
                            label="Concepto Exento Mensual"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_gravable_anuales"
                            label="Concepto Gravable Anuales"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_exento_anuales"
                            label="Concepto Exento Anuales"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_isr_retenido"
                            label="Concepto ISR Retenido"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_subsidio_aplicado"
                            label="Concepto Subsidio Aplicado"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_subsidio_pagado"
                            label="Concepto Subsidio Pagado"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider orientation="left" orientationMargin="0">Predeterminados Dias Horas</Divider>
                      <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_ordinario"
                            label="Ordinario"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_horas_extras"
                            label="Horas Extras"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_horas_extras_dobles"
                            label="Horas Extras Dobles"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_horas_extras_triples"
                            label="Horas Extras Triples"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_dias_aguinaldo"
                            label="Días Aguinaldo"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="concepto_dias_vacaciones_pagadas"
                            label="Días Vacaciones Pagadas"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    conceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ),
                },
                {
                  key: 'aguinaldo',
                  label: 'Aguinaldo',
                  children: (
                    <>
                      <Divider orientation="left" orientationMargin="0">Predeterminados Aguinaldo</Divider>
                      <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="tabla_integracion"
                            label="Tabla Integración"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona un concepto',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona un concepto">
                                {
                                    integracion.map((item)=><Option key={item.id} value={item.id}>{item.clave}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                            name="tipo_fecha_aguinaldo"
                            label="Fecha a Utilizar"
                            rules={[
                              {
                                  required: setup,
                                  message: 'Por favor selecciona una fecha',
                              },
                            ]}
                          >
                            <Select placeholder="Por favor selecciona una fecha">
                                {
                                    fechas.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                          <Form.Item
                            label="Tipos de Ausentismos"
                          >
                            <Row gutter={[8, 8]}>
                              {tiposAusentismos.map((item) => {
                                const key = `${item.source}-${item.id}`;
                                return (
                                  <Col span={24} key={key}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <span style={{ fontSize: 12 }}>
                                        {item.nombre || item.tipo}
                                      </span>
                                      <Switch
                                        size="small"
                                        checked={!!ausentismosSeleccionados[key]}
                                        onChange={(checked) => handleChangeAusentismo(key, checked, item)}
                                      />
                                    </div>
                                  </Col>
                                );
                              })}
                            </Row>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ),
                },
                {
                  key: 'variable',
                  label: 'Variable',
                  children: (
                    <>
                      <Divider orientation="left" orientationMargin="0">Conceptos Variables</Divider>
                      <Row gutter={[16, 16]}>
                        {conceptosVariables.map((item) => (
                          <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }} key={item.id}>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                border: '1px solid #d9d9d9',
                                borderRadius: '6px',
                                backgroundColor: '#fafafa',
                              }}
                            >
                              <span style={{ fontSize: 14, fontWeight: 500 }}>
                                ({item.clave}) {item.descripcion}
                              </span>
                              <Switch
                                checked={!!item.activo}
                                onChange={(checked) => handleChangeConceptoVariable(item.id, checked, item)}
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </>
                  ),
                },
                {
                  key: 'tipos_efectivo',
                  label: 'Tipos de Efectivo',
                  children: <TiposEfectivoConfig />,
                },
              ]}
            />
          </Form>
      }
    </PageApp>
}

export default ConfiguracionNominaPage;

{/* 
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                  <Form.Item
                                      name="descripcion"
                                      label="Descripción"
                                      rules={[
                                      {
                                          required: setup,
                                          message: 'Por favor agrega una descripción',
                                      },
                                      ]}
                                  >
                                      <Input placeholder="Por favor agrega una descripción" />
                                  </Form.Item>
                              </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="ayuda"
                                        label="Ayuda"
                                        rules={[
                                        {
                                            required: false,
                                            message: 'Por favor agrega una ayuda',
                                        },
                                        ]}
                                    >
                                        <TextArea placeholder="Por favor agrega una descripción" rows={4} maxLength={6}/>
                                    </Form.Item>
                                </Col>
                               
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="activo"
                                        label="Activo"
                                        >
                                        <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col> 
              */}